import React from "react";
import { CircularProgress, Box } from "@material-ui/core";

export const Spinner = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" className="w-full h-full">
      <CircularProgress color="secondary" />
    </Box>
  );
};
